import { render, staticRenderFns } from "./CTT04.vue?vue&type=template&id=63de5e20"
import script from "./CTT04.vue?vue&type=script&lang=js"
export * from "./CTT04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports